import React, { useCallback } from 'react';
import { BaseTour } from './BaseTour';
import { useWizardQuery, useCompleteWizardMutation } from '../../../hooks/useWizardsQuery';

const TOUR_STEPS = [
    {
        target: '#tour-stats-row-1',
        title: '👋 Welcome to Terriqon!',
        content: 'These are your quick stats — Forms assigned to you and total Submissions. Tap any card to jump to that section.',
        disableBeacon: true,
        placement: 'bottom',
        blockTargetInteraction: true,
    },
    {
        target: '#tour-stats-row-2',
        title: '🔄 Sync & Storage',
        content: 'Keep an eye on your Sync Status and device Storage. Make sure you sync regularly when online!',
        placement: 'bottom',
        blockTargetInteraction: true,
    },
    {
        target: '#tour-activity-chart',
        title: '📊 Activity & Submissions',
        content: 'Track your daily submission activity here. Below this chart, you will find your Recent Submissions to quickly review what you\'ve submitted and check their sync status.',
        placement: 'top',
        blockTargetInteraction: true,
    },
    {
        target: '#tour-fab-button',
        title: '➕ Start a New Form',
        content: 'Tap this button anytime to quickly start filling a new form. It\'s the fastest way to begin data collection.',
        placement: 'left',
        blockTargetInteraction: true,
    },
    {
        target: '#tour-bottom-nav',
        title: '🧭 Navigate the App',
        content: 'Use the bottom bar to switch between Dashboard, Forms, Chat, Sync, and Settings. Everything you need is one tap away.',
        placement: 'top',
        blockTargetInteraction: true,
    },
    {
        target: 'body',
        title: '🚀 You\'re All Set!',
        content: 'Start by tapping a form to fill out, or check the Forms tab to see everything assigned to you. Happy collecting!',
        placement: 'center',
        blockTargetInteraction: true,
    },
];

export const DashboardTour = () => {
    const wizardKey = 'sina_pwa_dashboard_tour_completed';
    const { data: wizardData, isLoading } = useWizardQuery(wizardKey);
    const completeMutation = useCompleteWizardMutation(wizardKey);

    const isCompleted = !!wizardData?.completed;

    const handleTourComplete = useCallback(() => {
        completeMutation.mutate(undefined, {
            onError: (error) => {
                console.warn('Failed to mark dashboard tour as completed via API', error);
            },
        });
    }, [completeMutation]);

    // Don't render while loading to avoid flash
    if (isLoading) return null;

    return (
        <BaseTour 
            steps={TOUR_STEPS} 
            storageKey={wizardKey}
            isCompleted={isCompleted}
            onTourComplete={handleTourComplete}
        />
    );
};
